import _ from 'lodash';
import React, { PureComponent } from 'react';

import { trackAnalyticsEvent } from '@eb/site-analytics';
import transform from '../transform';
import defaultSettings from './settings';
import userSettings from './userSettings';

import {
    PACKAGE_PATHS,
    PACKAGE_THREE,
    PACKAGE_THREE_PAGE,
    PACKAGE_THREE_PATH,
} from '../../constants/main';
import {
    GA_BOTTOM_LABEL,
    GA_CHOOSE_PACKAGE,
    GA_LEARN_MORE_CLICKED,
    GA_P1_LABEL,
    GA_P2_LABEL,
    GA_TOP_LABEL,
    PACKAGE_NAVIGATION_ACTION,
    PREMIUM_CTA_ACTION,
    PREMIUM_STICKY_CTA_ACTION,
} from '../../constants/analytics';
import { handleLoadDriftChatbot, loadCrazyEgg } from '../utils';

import PageTitle from '../../components/PageTitle';
import FeaturesExpansion from '../../components/FeaturesExpansion';
import Testimonials from '../../components/Testimonials';
import MainHeader from '../../components/MainHeader';
import ThreeColumnFeatures from '../../components/ThreeColumnFeatures';
import TwoColumnFeatures from '../../components/TwoColumnFeatures';
import ActionBanner from '../../components/ActionBanner';

export default class PackageThreePage extends PureComponent {
    componentDidMount() {
        const { isAuthenticated, tld } = this.props;

        handleLoadDriftChatbot(tld, isAuthenticated);

        loadCrazyEgg();
    }

    render() {
        const {
            activeScopeUserId,
            locale,
            isAuthenticated,
            goToPackageOne,
            goToPackageTwo,
            goToPackageComparison,
            redirectToPremium,
            assortmentsPricing,
            assortmentsTax,
            userPlan,
            packageTitles: { premium },
        } = this.props;
        const tabActions = [
            goToPackageOne.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P1_LABEL),
            goToPackageTwo.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P2_LABEL),
            _.noop,
        ];
        const {
            bottomBanner,
            featureListOne,
            featureListTwo,
            featureListThree,
            featureListFour,
            testimonials,
            featuresExpansion,
            mainHeader,
            middleBanner,
        } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            page: PACKAGE_THREE_PAGE,
            userSettings,
            userPlan,
        });

        trackAnalyticsEvent({
            action: GA_LEARN_MORE_CLICKED,
            category: GA_CHOOSE_PACKAGE,
            dimensions: {
                userId: activeScopeUserId,
                planLearnMore: PACKAGE_THREE_PATH,
                locale,
            },
        });

        return (
            <div>
                <PageTitle title={premium} />
                <MainHeader
                    {...mainHeader}
                    price={assortmentsPricing[PACKAGE_THREE]}
                    taxLabel={assortmentsTax[PACKAGE_THREE]}
                    tabActions={tabActions}
                    tabPaths={PACKAGE_PATHS}
                    onClick={redirectToPremium.bind(
                        null,
                        PREMIUM_CTA_ACTION,
                        GA_TOP_LABEL,
                    )}
                    onStickyClick={redirectToPremium.bind(
                        null,
                        PREMIUM_STICKY_CTA_ACTION,
                    )}
                />
                <ThreeColumnFeatures {...featureListOne} />
                <TwoColumnFeatures {...featureListTwo} />
                <TwoColumnFeatures
                    {...featureListThree}
                    reverseHorizontal={true}
                />
                <ThreeColumnFeatures
                    {...featureListFour}
                    removeVerticalPadding={true}
                />
                <ActionBanner
                    {...middleBanner}
                    onClick={redirectToPremium.bind(
                        null,
                        PREMIUM_CTA_ACTION,
                        GA_BOTTOM_LABEL,
                    )}
                />
                <Testimonials {...testimonials} />
                <FeaturesExpansion
                    {...featuresExpansion}
                    onClick={goToPackageComparison.bind(null, PACKAGE_THREE)}
                />
                <ActionBanner
                    {...bottomBanner}
                    onClick={redirectToPremium.bind(
                        null,
                        PREMIUM_CTA_ACTION,
                        GA_BOTTOM_LABEL,
                    )}
                />
            </div>
        );
    }
}
